<template>
    <top-bar-secondary-enhanced :renderCI="renderCI" v-if="isEnhancedLayout">
        <!-- Slot forwarding -->
        <template v-slot:module-action-left>
            <slot name="module-action-left"></slot>
        </template>

        <template v-slot:module-action-right>
            <slot name="module-action-right"></slot>
        </template>
    </top-bar-secondary-enhanced>

    <top-bar-secondary-classic
        :renderCI="renderCI"
        :navbar-toggle-breakpoint="navbarToggleBreakpoint"
        v-else
    >
        <!-- Slot forwarding -->
        <template v-slot:module-action-left>
            <slot name="module-action-left"></slot>
        </template>

        <template v-slot:module-action-right>
            <slot name="module-action-right"></slot>
        </template>
    </top-bar-secondary-classic>
</template>

<script>
import TopBarSecondaryClassic from "@/module/layout/top-bar-secondary-classic.vue";
import TopBarSecondaryEnhanced from "@/module/layout/top-bar-secondary-enhanced.vue";

export default {
    name: "TopBarSecondary",
    components: { TopBarSecondaryClassic, TopBarSecondaryEnhanced },
    props: {
        renderCI: {
            type: Boolean,
            default: false
        },
        navbarToggleBreakpoint: {
            type: String,
            default: "md"
        }
    },
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    }
};
</script>
